export const DO_NOT_ASSIGN_VALUE = 'DO_NOT_ASSIGN';

export const HIIDDEN_FOOTER_ROUTES = [
    '/proposals/preview',
    '/templates/edition',
];

export const MAX_FILE_SIZE = 20971520;

export const PROPOSAL_STATUS = {
    DRAFT: 'draft',
    GENERATED: 'generated',
};

export const TEMPLATE_LANGUAGES = {
    ES_MX: 'es-mx',
    EN_US: 'en-us',
};

export const TEMPLATE_TYPES = {
    PROPOSAL_TYPE: 'proposal',
    BOM_TYPE: 'bom',
    SYSTEM_TYPE: 'system',
    PDF_TYPE: 'pdf',
};

export const DEBOUNCE_TIME_500 = 500;
export const DEBOUNCE_TIME = 1500;
export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 75, 100];
